import React, { useContext, useState } from 'react'
import { Formik } from 'formik'
import { Button, Form, Grid, GridCell, NotificationInline,
   NotificationManagerContext, Text, View } from 'oio-react'
import { useParams } from 'react-router-dom'
import { Input, Textarea } from 'src/components/ConnectedForm'
import { useOrganization, useUpdateOrganization } from 'src/graphql/hooks'
import ThemeContext from 'src/libraries/contexts/Theme'

const SettingsContentInitiativeTypeAbout = () => {
   const { initiativeTypeId } = useParams()
   const { showNotification } = useContext(NotificationManagerContext)
   const [error, setError] = useState(null)
   const theme = useContext(ThemeContext)

   const { organization } = useOrganization()
   const { updateOrganization } = useUpdateOrganization()
   const initiativeType = organization.initiativeTypes.find(t => t.id === initiativeTypeId)

   const handleSaveInitiativeType = async (values, actions) => {
      try {
         await updateOrganization({
            initiativeTypes: [{
               operation: 'update',
               update: {
                  id: initiativeType.id,
                  ...values
               }
            }]
         })

         showNotification({
            message: 'Changes saved successfully!',
            title: 'Success!',
            type: 'success'
         })
      } catch (err) {
         setError(err)
      } finally {
         actions.setSubmitting(false)
      }
   }

   return (
      <View
         float="left"
         width="100%"
         borderRadius="3px"
         backgroundColor="#fff"
         padding="15px">
         {error && (
            <View marginBottom="18px">
               <NotificationInline
                  borderRadius="3px"
                  textSize="1.5"
                  type="error"
                  title="Error"
                  message={error.message}
               />
            </View>
         )}
         <Formik
            initialValues={{
               description: initiativeType.description || '',
               highlightColor: initiativeType.highlightColor || '',
               iconName: initiativeType.iconName || '',
               namePlural: initiativeType.namePlural,
               nameSingular: initiativeType.nameSingular,
               slug: initiativeType.slug
            }}
            onSubmit={handleSaveInitiativeType}
            render={({ handleSubmit, isSubmitting }) => (
               <Form
                  elementAppearance="plain"
                  elementBackgroundColor="#eee"
                  elementFocusBackgroundColor="#f3f3f3"
                  onSubmit={handleSubmit}>
                  <Grid spacing="15px">
                     <GridCell colspan="5">
                        <Text size="2" weight="medium">
                           Content Type Name
                        </Text>
                        <Text size="1.5" color="#999">
                           (plural)
                        </Text>
                     </GridCell>
                     <GridCell colspan="7">
                        <Input
                           maxLength="100"
                           size="lg"
                           name="namePlural"
                        />
                     </GridCell>
                     <GridCell colspan="5">
                        <Text size="2" weight="medium">
                           Content Type Name
                        </Text>
                        <Text size="1.5" color="#999">
                           (singular)
                        </Text>
                     </GridCell>
                     <GridCell colspan="7">
                        <Input
                           maxLength="100"
                           size="lg"
                           name="nameSingular"
                        />
                     </GridCell>
                     <GridCell colspan="5">
                        <Text size="2" weight="medium">
                           Content Type URL
                        </Text>
                        <Text size="1.5" color="#999">
                           Link to this Content Type
                        </Text>
                     </GridCell>
                     <GridCell colspan="2">
                        <View
                           display="flex"
                           height="30px"
                           alignItems="center">
                           <Text size="1.5" color="#999">
                              /explore/
                           </Text>
                        </View>
                     </GridCell>
                     <GridCell colspan="5">
                        <Input size="sm" name="slug" />
                     </GridCell>
                     <GridCell colspan="5">
                        <Text size="2" weight="medium">
                           Content Type Description
                        </Text>
                        <Text size="1.5" color="#999">
                           A short description about this content type
                        </Text>
                     </GridCell>
                     <GridCell colspan="7">
                        <Textarea
                           size="sm"
                           name="description"
                           rows="5"
                        />
                     </GridCell>
                     <GridCell colspan="5">
                        <Text size="2" weight="medium">
                           Icon Name
                        </Text>
                     </GridCell>
                     <GridCell colspan="7">
                        <Input size="sm" name="iconName" />
                     </GridCell>
                     <GridCell colspan="5">
                        <Text size="2" weight="medium">
                           Highlight Color
                        </Text>
                     </GridCell>
                     <GridCell colspan="7">
                        <Input size="sm" name="highlightColor" />
                     </GridCell>
                     <GridCell colspan="12">
                        <View
                           display="flex"
                           justifyContent="flex-end"
                           width="100%"
                           borderTop="1px solid #eee"
                           paddingTop="10px">
                           <Button
                              type="submit"
                              name="Save Changes"
                              mode={isSubmitting ? 'loading' : 'normal'}
                              color={theme.protoSettingsHighlightBackgroundColor}
                              textColor={theme.protoSettingsHighlightForegroundColor}
                              textWeight="medium"
                              size="sm"
                              textSize="0.9"
                              padding="25px"
                           />
                        </View>
                     </GridCell>
                  </Grid>
               </Form>
            )}
         />
      </View>
   )
}

export default SettingsContentInitiativeTypeAbout
